import React from 'react';
import { Card, CardContent } from './ui/card';
import { ShieldAlert } from 'lucide-react';

/*
 * Shown at the top of pages whose UI was ported from V2 but whose BACKEND does not exist on the
 * Spring server yet (they still call V2's FastAPI routes). Without this they showed a spinner
 * forever and then an empty table - which reads as "there is no data", not "this is not built".
 * Honest state beats a convincing blank. Owner walkthrough finding, 2026-08-21.
 */
export default function NotWiredBanner({ what, legacyUrl, legacyLabel }) {
  return (
    <Card className="rounded-2xl border-warning/40 bg-warning/10 shadow-none mb-4" data-testid="not-wired-banner">
      <CardContent className="p-4 sm:p-5 flex items-start gap-3 text-sm text-foreground/90">
        <ShieldAlert className="h-5 w-5 text-warning shrink-0 mt-0.5" />
        <div className="min-w-0">
          <div className="font-semibold text-foreground">{what} is not wired to this server yet.</div>
          <div className="text-muted-foreground mt-1">
            This page was carried over from the V2 dashboard and still expects V2's API, which the
            NecroMancer server does not have. Nothing below will load.
            {legacyUrl && (
              <> Until it is built, use the existing page at{' '}
                <a className="underline text-foreground break-all" href={legacyUrl} target="_blank" rel="noreferrer">{legacyLabel || legacyUrl}</a>.</>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
